<template>
  <div class="tab-content tab-message">
    <span>{{L10n(message)}}</span>
  </div>
</template>

<script>
export default {
  name: 'TabDefault',
  props: {
    message: { type: String, default: 'select-a-company' }
  }
}
</script>

<style lang="stylus">
  .tab-message{
    display flex
    justify-content center
    align-items center
    color #6d7278
  }
</style>
